import {
    DashboardOutlined,
    Link,
    MonitorHeartOutlined,
    Payment,
    PeopleOutlineOutlined,
    PersonOutlined,
    PublicOutlined,
    ReceiptLongOutlined,
    ReceiptOutlined,
    Report,
    SettingsOutlined,
    SupervisorAccountOutlined,
} from "@mui/icons-material";

export const sidebarData = [
    {
        id: 1,
        name: "dashboard",
        icon: <DashboardOutlined />,
        subfields: [
            {
                id: 1,
                name: "dashboard",
                href: "/dashboard",
                permissions: ["READ DASHBOARD", "READ SIMPLE_DASHBOARD"],
            },
        ],
    },

    {
        id: 2,
        name: "Roles",
        icon: <SupervisorAccountOutlined />,
        subfields: [
            {
                id: 1,
                name: "roles",
                href: "/roles",
                permissions: [
                    "CREATE ROLE",
                    "READ ROLE",
                    "UPDATE ROLE",
                    "DELETE ROLE",
                ],
            },
        ],
    },

    {
        id: 3,
        name: "users",
        icon: <PersonOutlined />,
        subfields: [
            {
                id: 1,
                name: "users",
                href: "/users",
                permissions: [
                    "CREATE USER",
                    "READ USER",
                    "UPDATE USER",
                    "DELETE USER",
                ],
            },
        ],
    },

    {
        id: 4,
        name: "regions",
        icon: <PublicOutlined />,
        subfields: [
            {
                id: 1,
                name: "districts",
                href: "/regions/districts",
                permissions: [
                    "CREATE DISTRICT",
                    "READ DISTRICT",
                    "UPDATE DISTRICT",
                    "DELETE DISTRICT",
                ],
            },

            {
                id: 1,
                name: "powerstations",
                href: "/powerstations",
                permissions: [
                    "CREATE POWERSTATION",
                    "READ POWERSTATION",
                    "UPDATE POWERSTATION",
                    "DELETE POWERSTATION",
                ],
            },
            {
                id: 2,
                name: "villages",
                href: "/regions/villages",
                permissions: [
                    "CREATE VILLAGE",
                    "READ VILLAGE",
                    "UPDATE VILLAGE",
                    "DELETE VILLAGE",
                ],
            },

            {
                id: 3,
                name: "hamlet",
                href: "/regions/hamlets",
                permissions: [
                    "CREATE HAMLET",
                    "READ HAMLET",
                    "UPDATE HAMLET",
                    "DELETE HAMLET",
                ],
            },
        ],
    },

    {
        id: 6,
        name: "Connection Info",
        icon: <Link />,
        subfields: [
            {
                id: 1,
                name: "unit charges",
                href: "/connections/unit-charges",
                permissions: [
                    "CREATE RULE",
                    "READ RULE",
                    "UPDATE RULE",
                    "DELETE RULE",
                ],
            },

            {
                id: 3,
                name: "surcharge",
                href: "/connections/surcharge",
                permissions: [
                    "CREATE SURCHARGE",
                    "READ SURCHARGE",
                    "UPDATE SURCHARGE",
                    "DELETE SURCHARGE",
                ],
            },

            {
                id: 4,
                name: "line rent",
                href: "/connections/line-rent",
                permissions: [
                    "CREATE LINE_RENT",
                    "READ LINE_RENT",
                    "UPDATE LINE_RENT",
                ],
            },

            {
                id: 2,
                name: "connection types",
                href: "/connections/types",
                permissions: [
                    "CREATE CONNECTION_TYPE",
                    "READ CONNECTION_TYPE",
                    "UPDATE CONNECTION_TYPE",
                    "DELETE CONNECTION_TYPE",
                ],
            },

            {
                id: 6,
                name: "price types",
                href: "/connections/price-types",
                permissions: [
                    "CREATE PRICE_TYPE",
                    "READ PRICE_TYPE",
                    "EDIT PRICE_TYPE",
                    "DELETE PRICE_TYPE",
                    "REPLACE PRICE_TYPE",
                    "READ DEFAULT_PRICE_TYPE",
                ],
            },
        ],
    },

    {
        id: 7,
        name: "consumer",
        icon: <PeopleOutlineOutlined />,
        subfields: [
            {
                id: 1,
                name: "consumers",
                href: "/customer/consumers",
                permissions: [
                    "CREATE CUSTOMER",
                    "READ CUSTOMER",
                    "UPDATE CUSTOMER",
                    "DELETE CUSTOMER",
                ],
            },

            {
                id: 2,
                name: "property type",
                href: "/customer/property-type",
                permissions: [
                    "CREATE PROPERTY_TYPE",
                    "READ PROPERTY_TYPE",
                    "UPDATE PROPERTY_TYPE",
                    "DELETE PROPERTY_TYPE",
                ],
            },

            {
                id: 3,
                name: "property",
                href: "/customer/property",
                permissions: [
                    "CREATE PROPERTY",
                    "READ PROPERTY",
                    "UPDATE PROPERTY",
                    "DELETE PROPERTY",
                ],
            },

            {
                id: 4,
                name: "Meters",
                href: "/customer/meters",
                permissions: [
                    "CREATE METER",
                    "READ METER",
                    "UPDATE METER",
                    "DELETE METER",
                ],
            },

            {
                id: 5,
                name: "Add New Consumer",
                href: "/customer/connection",
                permissions: ["CREATE CUSTOMER"],
            },
        ],
    },

    {
        id: 11,
        name: "payment",
        icon: <Payment />,
        subfields: [
            {
                id: 1,
                name: "payment method",
                href: "/payment/method",
                permissions: [
                    "CREATE PAYMENT_METHOD",
                    "READ PAYMENT_METHOD",
                    "DELETE PAYMENT_METHOD",
                ],
            },

            {
                id: 2,
                name: "payment head",
                href: "/payment/head",
                permissions: [
                    "CREATE PAYMENT_HEAD",
                    "READ PAYMENT_HEAD",
                    "UPDATE PAYMENT_HEAD",
                    "DELETE PAYMENT_HEAD",
                ],
            },

            // {
            //     id: 3,
            //     name: "payment",
            //     href: "/payment",
            //     permissions: [
            //         "CREATE PAYMENT",
            //         "READ PAYMENT",
            //         "UPDATE PAYMENT",
            //         "DELETE PAYMENT",
            //     ],
            // },

            // {
            //     id: 4,
            //     name: "Collection",
            //     href: "/payment/collection",
            //     permissions: [
            //         "CREATE PAYMENT_COLLECTION",
            //         "READ PAYMENT_COLLECTION",
            //         "UPDATE PAYMENT_COLLECTION",
            //         "DELETE PAYMENT_COLLECTION",
            //     ],
            // },
        ],
    },

    {
        id: 8,
        name: "bills",
        icon: <ReceiptOutlined />,
        subfields: [
            {
                id: 1,
                name: "readings",
                href: "/bills/readings",
                permissions: [
                    "CREATE READING",
                    "READ READING",
                    "DELETE READING",
                ],
            },
            {
                id: 15,
                name: "reading images",
                href: "/bills/readings/images",
                permissions: ["READ READING_IMAGE"],
            },
            {
                id: 16,
                name: "delete reading excel",
                href: "/bills/reading/delete-excel",
                permissions: ["DELETE READING_EXCEL"],
            },

            {
                id: 9,
                name: "Negative Reading By Excel",
                href: "/bills/reading/excel",
                permissions: ["CREATE READING_EXCEL"],
            },
            {
                id: 2,
                name: "Update readings",
                href: "/bills/readings/update",
                permissions: ["UPDATE READING"],
            },

            {
                id: 3,
                name: "Update Dates",
                href: "/bills/readings/update-date",
                permissions: ["UPDATE READING_DATES"],
            },

            // {
            //     id: 9,
            //     name: "Active Inactive (R-B-C)",
            //     href: "/bills/readings/collections/bills/active-inactive",
            //     permissions: ["ACTIVATE DEACTIVATE"],
            // },

            // {
            //     id: 5,
            //     name: "Arrears",
            //     href: "/bills/arrears",
            //     permissions: ["READ DEFAULTERS_REPORT"],
            // },

            {
                id: 6,
                name: "Print Bill",
                href: "/bills",
                permissions: ["GENERATE BILL"],
            },

            // {
            //     id: 15,
            //     name: "Print Bill History",
            //     href: "/bills/print-bill-history",
            //     permissions: ["READ_BILL_HISTORY"],
            // },

            {
                id: 7,
                name: "collection",
                href: "/bills/collection",
                permissions: ["READ COLLECTION"],
            },
            // {
            //     id: 17,
            //     name: "month wise collection",
            //     href: "/bills/collection-month-wise",
            //     permissions: ["READ MONTHLY_COLLECTION_REPORT"],
            // },
            // {
            //     id: 18,
            //     name: "month wise current units",
            //     href: "/bills/current-units-month-wise",
            //     permissions: ["READ MONTHLY_CURRENT_UNITS_REPORT"],
            // },

            {
                id: 16,
                name: "Collect Connection Charges",
                href: "/bills/collect-connection-charges",
                permissions: ["COLLECT BILL"],
            },

            // {
            //     id: 8,
            //     name: "Bill Generation Report",
            //     href: "/bills/bill-report",
            //     permissions: ["GENERATE BILL"],
            // },

            // {
            //     id: 9,
            //     name: "Arrears New",
            //     href: "/bills/arrears/new",
            //     permissions: ["READ DEFAULTERS_REPORT"],
            // },

            {
                id: 12,
                name: "Advance Payments",
                href: "/advance",
                permissions: ["CREATE ADVANCE", "READ ADVANCE"],
            },
        ],
    },

    // {
    //     id: 12,
    //     name: "Consumer Summary",
    //     icon: <AssessmentOutlined />,
    //     subfields: [
    //         {
    //             id: 1,
    //             name: "consumer_summary",
    //             href: "/report/customer",
    //             permissions: ["READ CUSTOMER_REPORT"],
    //         },
    //     ],
    // },

    // {
    //     id: 15,
    //     name: "Monthly Summary",
    //     icon: <CalendarMonthOutlined />,
    //     subfields: [
    //         {
    //             id: 1,
    //             name: "monthly-summary",
    //             href: "/report/monthly-summary",
    //             permissions: ["READ MONTHLY_SUMMARY_REPORT"],
    //         },
    //     ],
    // },

    // {
    //     id: 16,
    //     name: "Recovery Plan",
    //     icon: <Loop />,
    //     subfields: [
    //         {
    //             id: 1,
    //             name: "recovery-plan",
    //             href: "/report/recovery-plan",
    //             // permissions: ["READ MONTHLY_SUMMARY_REPORT"],
    //             permissions: ["READ RECOVERY_PLAN"],
    //         },
    //     ],
    // },

    {
        id: 13,
        name: "Receipt / Slips",
        icon: <ReceiptLongOutlined />,
        subfields: [
            {
                id: 1,
                name: "Connection Slip",
                href: "/slips/connection",
                permissions: ["CREATE SLIP", "READ SLIP", "DELETE SLIP"],
            },

            {
                id: 2,
                name: "Meter Replacement",
                href: "/slips/meter-replacement",
                permissions: ["CREATE SLIP", "READ SLIP", "DELETE SLIP"],
            },

            {
                id: 3,
                name: "Arrears",
                href: "/slips/arrears",
                permissions: ["CREATE SLIP", "READ SLIP", "DELETE SLIP"],
            },
        ],
    },
    ,
    {
        id: 15,
        name: "Reports",
        icon: <Report />,
        subfields: [
            {
                id: 4,
                name: "Connections Report",
                href: "/customer/meters",
                permissions: [
                    "CREATE METER",
                    "READ METER",
                    "UPDATE METER",
                    "DELETE METER",
                ],
            },
            {
                id: 1,
                name: "Arrears",
                href: "/bills/arrears",
                permissions: ["READ DEFAULTERS_REPORT"],
            },

            {
                id: 2,
                name: "Arrears New",
                href: "/bills/arrears/new",
                permissions: ["READ DEFAULTERS_REPORT"],
            },

            {
                id: 3,
                name: "month wise collection",
                href: "/bills/collection-month-wise",
                permissions: ["READ MONTHLY_COLLECTION_REPORT"],
            },
            {
                id: 4,
                name: "month wise current units",
                href: "/bills/current-units-month-wise",
                permissions: ["READ MONTHLY_CURRENT_UNITS_REPORT"],
            },

            {
                id: 5,
                name: "Advance Summary",
                href: "/advance/summary",
                permissions: ["READ ADVANCE"],
            },

            {
                id: 6,
                name: "Advance Payments",
                href: "/advance",
                permissions: ["CREATE ADVANCE", "READ ADVANCE"],
            },

            {
                id: 7,
                name: "Credit  ledger Summary",
                href: "/credit/payment/leisure",
                permissions: ["READ CREDIT_PAYMENT"],
            },

            {
                id: 8,
                name: "Credit ledger Month Wise",
                href: "/credit/payment/leisure/month-wise",
                permissions: ["READ CREDIT_PAYMENT"],
            },

            {
                id: 9,
                name: "Monthly Summary",
                href: "/report/monthly-summary",
                permissions: ["READ MONTHLY_SUMMARY_REPORT"],
            },

            {
                id: 10,
                name: "Consumer Summary",
                href: "/report/customer",
                permissions: ["READ CUSTOMER_REPORT"],
            },

            {
                id: 11,
                name: "Recovery Plan",
                href: "/report/recovery-plan",
                // permissions: ["READ MONTHLY_SUMMARY_REPORT"],
                permissions: ["READ RECOVERY_PLAN"],
            },
            {
                id: 12,
                name: "Unit Consumption",
                href: "/unit-consumption",
                permissions: ["READ UNIT_CONSUMPTION"],
            },
            {
                id: 6,
                name: "Consumer History",
                href: "/customer/timeline",
                permissions: ["READ CUSTOMER_HISTORY"],
            },

            {
                id: 4,
                name: "Blank reading list",
                href: "/bills/readings/blank/list",
                permissions: [
                    "CREATE READING",
                    "READ READING",
                    "DELETE READING",
                ],
            },
            {
                id: 15,
                name: "Print Bill History",
                href: "/bills/print-bill-history",
                permissions: ["READ_BILL_HISTORY"],
            },
            {
                id: 8,
                name: "Bill Generation Report",
                href: "/bills/bill-report",
                permissions: ["GENERATE BILL"],
            },
        ],
    },

    {
        id: 10,
        name: "settings",
        icon: <SettingsOutlined />,
        subfields: [
            {
                id: 1,
                name: "settings",
                href: "/settings",
                permissions: [
                    "CREATE SETTING",
                    "READ SETTING",
                    "UPDATE SETTING",
                    "DELETE SETTING",
                ],
            },
            {
                id: 9,
                name: "Active Inactive (R-B-C)",
                href: "/bills/readings/collections/bills/active-inactive",
                permissions: ["ACTIVATE DEACTIVATE"],
            },

            {
                id: 14,
                name: "Reset  Negative Reading",
                href: "/bills/readings/reset",
                permissions: ["RESET CREDIT_PAYMENT"],
            },

            {
                id: 15,
                name: "Reset Credit System",
                href: "/bills/readings/credit/reset",
                permissions: ["UPDATE READING"],
            },

            {
                id: 10,
                name: "Fixed Bill",
                href: "/fixed-bill/view",
                permissions: ["READ_BILLING_RULE"],
            },

            {
                id: 11,
                name: "Complete Reading Status",
                href: "/bills/complete-reading-status",
                permissions: ["COMPLETE READING_STATUS"],
            },
            // {
            //     id: 16,
            //     name: "Change BaseLine Units",
            //     href: "/bills/changed-baseline-units",
            //     permissions: ["CHANGE BASELINE UNITS"],
            // }
        ],
    },

    {
        id: 9,
        name: "Logs",
        icon: <MonitorHeartOutlined />,
        subfields: [
            {
                id: 1,
                name: "logs",
                href: "/logs",
                permissions: ["READ LOGS"],
            },
        ],
    },
];
